import { ref } from 'vue';

const productsCount = ref(0);
export { productsCount };
